import { createSelector } from 'reselect'
import { getAddressOrderUtil, getOrderProductsOrderUtil, getPromoCodesOrderUtil } from 'models/daos/order/utils'

/**
 * Returns a selector that gets the order's OrderProducts.
 * @returns {Selector}
 */
function getAddressOrderSelector () {
  return createSelector(
    state => state && state.address,
    (state, props) => state && state.orders.data[props.match.params.key],
    (address, order) => getAddressOrderUtil(order, address)
  )
}

/**
 * Gets a selector that gets the order's `OrderProducts`.
 * @returns {Selector}
 */
function getOrderProductsOrderSelector () {
  return createSelector(
    (state, props) => state && state.orders.data[props.match.params.key],
    state => state && state.orderProducts,
    (order, orderProducts) => getOrderProductsOrderUtil(order, orderProducts)
  )
}

/**
 * Gets a selector that gets the order's `PromoCode`.
 * @returns {Selector}
 */
function getPromoCodesOrderSelector () {
  return createSelector(
    (state, props) => props.instance || state.orders.data[props.match.params.key],
    state => state && state.promoCodes,
    (order, promoCodes) => getPromoCodesOrderUtil(order, promoCodes)
  )
}

export {
  getAddressOrderSelector,
  getOrderProductsOrderSelector,
  getPromoCodesOrderSelector
}
